/*
Muestra una pop up modal para confirmar una accion. (delete y otros)
Autor: Benjamín León
fecha: 2024-10-25
*/
import React from 'react'

interface ConfirmationModalProps {
  message: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
        <p className="mb-4 text-gray-800 text-center">{message}</p>
        <div className="flex justify-around">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none"
            onClick={onConfirm}
          >
            Si
          </button>
          <button
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 focus:outline-none"
            onClick={onCancel}
          >
            No
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal
